export type NumberFormatConfig = {
  pattern: string
  group: string
  decimal: string
  fractionDigits: number
}

export const DEFAULT_NUMBER_FORMAT_PATTERN = '#,###.##'

/** Epic/CMS-known masks today (documentation + optional bootstrap checks). */
export const SUPPORTED_NUMBER_FORMAT_PATTERNS: readonly string[] = ['#,###.##', '#.###,##']
